import React, {} from "react"

export default function OpenWaitingListPopup() {
   this.setState({ waiting_list_popup_open: true,  })
}
